export default "__VITE_ASSET__BlbfxF$7__"